import {
  InterProcessEvents,
  InterProcessStore
} from "./chunk-XVNHYOIL.js";

// src/lib/impl/GlobalEvents.ts
var GlobalEventsInstance = class extends InterProcessEvents {
  constructor() {
    super("global.events");
  }
  onceOrTimeout = async (event, callback, timeout, forwardTimeout) => {
    return await new Promise((resolve) => {
      const onCallback = async () => {
        await callback();
        clearTimeout(t);
        if (typeof forwardTimeout === "function") {
          forwardTimeout(null);
        }
        resolve();
      };
      const t = setTimeout(
        () => {
          super.off(event, onCallback);
          resolve();
        },
        timeout ?? 120 * 1e3
      );
      if (typeof forwardTimeout === "function") {
        forwardTimeout(t);
      }
      super.once(event, onCallback);
    });
  };
};
var globalEvents = new GlobalEventsInstance();
if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  window._GlobalEvents = globalEvents;
}
var GlobalEvents = globalEvents;

// src/lib/impl/QueryStore.ts
var QueryStoreInstance = class extends InterProcessStore {
  constructor() {
    super("query.store");
  }
};
var QueryStore = new QueryStoreInstance();

// src/lib/react/use-global-event.ts
import { useEffect, useRef } from "react";
var useGlobalEvent = (eventName, callback) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => {
    const listener = (...args) => callbackRef.current(...args);
    GlobalEvents.on(eventName, listener);
    return () => {
      GlobalEvents.off(eventName, listener);
    };
  }, [eventName]);
};

export {
  GlobalEvents,
  QueryStore,
  useGlobalEvent
};
//# sourceMappingURL=chunk-25IAV6Y3.js.map